import { reportAPIFailure } from 'src/dataLayer/remoteData/rollbar/reportAPIErrors';
import { DefaultFailureHandler, UnsuccessfulResponseError } from './types';
import { RequestParams } from 'src/dataLayer/remoteData/babbelAPI/makeAjaxRequest/types';

export const successHandler = async <T>(response: Response): Promise<T> => {
  if (response.ok) {
    return response.json() as Promise<T>;
  }

  const { error } = (await response.json()) as { error: UnsuccessfulResponseError };

  // we need to destructure error attribute otherwise
  // it will have { error: error {} } structure
  // TODO: fix this by e.g. assigning the enhanced error object
  // to a variable and pass it to throw
  // eslint-disable-next-line no-throw-literal, @typescript-eslint/no-throw-literal
  throw {
    ...error,
    status: response.status
  };
};

export const defaultFailureHandler: DefaultFailureHandler<RequestParams> = (error, { payload }) => {
  // TODO: Remove this lint when reportAPIFailure has typings
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  reportAPIFailure(error, payload);
  throw error;
};
